import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { AdapterDateFns }
  from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider }
  from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker }
  from '@mui/x-date-pickers/TimePicker';


type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  helperText?: string;
  required?: boolean;
  size?: 'small' | 'medium';
};


function parseTimeValue(
  value: string | null | undefined,
): Date | null {
  if (!value) {
    return null;
  }

  const match =
    /^(\d{2}):(\d{2})$/.exec(value);

  if (!match) {
    return null;
  }

  const hour = Number(match[1]);
  const minute = Number(match[2]);

  if (
    hour < 0
    || hour > 23
    || minute < 0
    || minute > 59
  ) {
    return null;
  }

  const parsedTime = new Date();

  parsedTime.setHours(
    hour,
    minute,
    0,
    0,
  );

  return parsedTime;
}


export default function ProaTimePicker({
  label,
  value,
  onChange,
  helperText,
  required = false,
  size = 'small',
}: Props) {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={es}
    >
      <TimePicker
        label={label}
        value={parseTimeValue(value)}
        ampm={false}
        format="HH:mm"
        views={[
          'hours',
          'minutes',
        ]}
        onChange={(selectedTime) => {
          if (
            !selectedTime
            || Number.isNaN(
              selectedTime.getTime(),
            )
          ) {
            onChange('');
            return;
          }

          onChange(
            format(
              selectedTime,
              'HH:mm',
            ),
          );
        }}
        slotProps={{
          textField: {
            size,
            fullWidth: true,
            required,
            helperText,
            sx: {
              '& .MuiInputBase-root': {
                color: '#f8fafc',
                bgcolor:
                  'rgba(15,23,42,0.44)',
              },
              '& .MuiInputLabel-root': {
                color: '#94a3b8',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor:
                  'rgba(148,163,184,0.28)',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor:
                  'rgba(56,189,248,0.46)',
              },
              '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#38bdf8',
              },
              '& .MuiSvgIcon-root': {
                color: '#7dd3fc',
              },
            },
          },
          actionBar: {
            actions: [
              'clear',
            ],
          },
        }}
      />
    </LocalizationProvider>
  );
}